module.exports = __webpack_public_path__ + "media/images/vp/icon.vote.star.red-b4a7094945317b6909ce3f93890a9f1e.svg";